import React from "react";

import { s360ConfigService } from "./Services/S360Config";
import { Tooltip } from "@mui/material";

function StartUp(props) {
  const returnPostion = () => {
    if (s360ConfigService?.config?.preview) {
      return { display: "none" };
    } else if (
      s360ConfigService?.config?.configDetails?.chatPosition?.horizontal ===
      "left"
    ) {
      return {
        left: s360ConfigService?.config?.configDetails.connectToNextiva
          ? "16px"
          : "1rem",
      };
    }
    return {
      [s360ConfigService?.config?.configDetails?.chatPosition?.horizontal]:
        "2rem",
    };
  };
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const tooltipTipPosition =
    s360ConfigService.config.configDetails?.chatPosition?.horizontal === "right"
      ? "left"
      : "right";
  return (
    <div
      style={returnPostion()}
      className={
        s360ConfigService.config?.preview
          ? "s360-startup-float-container-preview"
          : `s360-startup-float-container${isFullScreen ? "-fs" : ""}`
      }
      id="test-container"
    >
      {props.notificationChild}
      {
        <Tooltip
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "preventOverflow",
                  options: {
                    boundary: "window",
                  },
                },
              ],
            },
            tooltip: {
              sx: {
                visibility: s360ConfigService.config.connectToNextiva
                  ? "visible"
                  : "hidden",
                backgroundColor: "#222648 !important",
                borderRadius: "4px",
                width: "150px",
                height: "32px",
                padding: "8px 16px",
                marginBottom: "10%",
                fontFamily: "Lato",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.15px",
                textAlign: "center",
              },
            },
          }}
          title="Connect with Nextiva"
          placement={tooltipTipPosition}
        >
          <div
            className={
              !s360ConfigService?.config?.connectToNextiva
                ? "s360-startup-float-container-launch-icon"
                : "s360-startup-float-container-launch-icon-CNXT"
            }
            onClick={props.actions.onStartUpClick}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ...s360ConfigService.config?.customDesign
                ?.startupFloatContainerLaunchIcon,
              position: "relative",
              left: "0px",
            }}
          >
            {s360ConfigService?.config?.connectToNextiva ? (
              <svg
                width="30"
                height="30"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="20" fill="#005FEC" />
                <path
                  d="M20.6725 33.1802C19.8317 33.1802 19.1002 32.8799 18.4779 32.2794C17.8555 31.668 17.5444 30.9419 17.5444 30.1012C17.5444 29.2605 17.8555 28.5508 18.4779 27.9721C19.1002 27.3935 19.8317 27.1041 20.6725 27.1041C21.5132 27.1041 22.2392 27.3935 22.8507 27.9721C23.473 28.5508 23.7842 29.2605 23.7842 30.1012C23.7842 30.9419 23.473 31.668 22.8507 32.2794C22.2392 32.8799 21.5132 33.1802 20.6725 33.1802ZM18.8382 17.7526H13.6301C13.521 17.2831 13.4336 16.7863 13.3681 16.2622C13.3135 15.7273 13.2862 15.2578 13.2862 14.8538C13.2862 13.4344 13.5974 12.217 14.2197 11.2016C14.8421 10.1862 15.7265 9.40556 16.8729 8.85964C18.0193 8.30281 19.3786 8.02439 20.9509 8.02439C22.6104 8.02439 24.0189 8.36832 25.1762 9.05617C26.3336 9.7331 27.2125 10.5902 27.813 11.6274C28.4244 12.6647 28.7302 13.7237 28.7302 14.8047C28.7302 15.9183 28.5882 16.8355 28.3043 17.5561C28.0314 18.2767 27.6765 18.8772 27.2398 19.3576C26.8031 19.838 26.3554 20.2856 25.8969 20.7005C25.3182 21.2137 24.7996 21.7596 24.341 22.3383C23.8824 22.917 23.6531 23.714 23.6531 24.7294H17.8228C17.8228 23.8123 17.9429 23.0534 18.1831 22.4529C18.4233 21.8415 18.7617 21.2956 19.1985 20.8152C19.6461 20.3348 20.1593 19.838 20.738 19.3248C21.5022 18.6697 22.0536 18.0638 22.3921 17.5069C22.7415 16.9392 22.9162 16.2513 22.9162 15.4434C22.9162 14.7555 22.736 14.1823 22.3757 13.7237C22.0263 13.2652 21.4804 13.0359 20.738 13.0359C19.93 13.0359 19.3841 13.3143 19.1002 13.8711C18.8163 14.4171 18.6744 15.0612 18.6744 15.8037C18.6744 16.1094 18.6908 16.4369 18.7235 16.7863C18.7563 17.1248 18.7945 17.4469 18.8382 17.7526Z"
                  fill="white"
                />
                <path
                  d="M22.1778 32.6166C21.7256 32.9188 21.1939 33.0801 20.65 33.0801C19.9207 33.0801 19.2212 32.7903 18.7055 32.2746C18.1898 31.7589 17.9 31.0594 17.9 30.3301C17.9 29.7862 18.0613 29.2545 18.3635 28.8023C18.6657 28.35 19.0951 27.9976 19.5976 27.7894C20.1001 27.5813 20.6531 27.5268 21.1865 27.6329C21.72 27.739 22.21 28.0009 22.5946 28.3855C22.9792 28.7701 23.2411 29.2601 23.3472 29.7936C23.4533 30.327 23.3988 30.88 23.1907 31.3825C22.9826 31.885 22.6301 32.3144 22.1778 32.6166Z"
                  fill="#F8B400"
                  stroke="white"
                />
              </svg>
            ) : (
              <svg
                width="32"
                height="32"
                viewBox="0 0 14 15"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.6875 12.125V12.5625L7.65625 11.0859C7.875 10.9219 8.14844 10.8125 8.44922 10.8125H12.25C12.4688 10.8125 12.6875 10.6211 12.6875 10.375V2.5C12.6875 2.28125 12.4688 2.0625 12.25 2.0625H1.75C1.50391 2.0625 1.3125 2.28125 1.3125 2.5V10.375C1.3125 10.6211 1.50391 10.8125 1.75 10.8125H4.375C5.08594 10.8125 5.6875 11.4141 5.6875 12.125ZM5.66016 14.2305L5.52344 14.3125L5.05859 14.668C4.92188 14.7773 4.75781 14.7773 4.59375 14.7227C4.45703 14.6406 4.375 14.5039 4.375 14.3125V13.7383V13.5742V13.5469V13.4375V12.125H3.0625H1.75C0.765625 12.125 0 11.3594 0 10.375V2.5C0 1.54297 0.765625 0.75 1.75 0.75H12.25C13.207 0.75 14 1.54297 14 2.5V10.375C14 11.3594 13.207 12.125 12.25 12.125H8.44922L5.6875 14.2031L5.66016 14.2305ZM4.15625 4.6875H9.84375C10.1992 4.6875 10.5 4.98828 10.5 5.34375C10.5 5.72656 10.1992 6 9.84375 6H4.15625C3.77344 6 3.5 5.72656 3.5 5.34375C3.5 4.98828 3.77344 4.6875 4.15625 4.6875ZM4.15625 7.3125H7.21875C7.57422 7.3125 7.875 7.61328 7.875 7.96875C7.875 8.35156 7.57422 8.625 7.21875 8.625H4.15625C3.77344 8.625 3.5 8.35156 3.5 7.96875C3.5 7.61328 3.77344 7.3125 4.15625 7.3125Z"
                  style={
                    s360ConfigService.config?.customConfig
                      ?.startupFloatContainerLaunchIconFill
                  }
                />
              </svg>
            )}
          </div>
        </Tooltip>
      }
    </div>
  );
}

export default StartUp;
